// extracted by mini-css-extract-plugin
export default {"cls1":"r_sUC0YEwtS133AypDS2","cls2":"wXlyGA0j_yOMVdFPmtxx r_sUC0YEwtS133AypDS2"};